<template>
  <div>
    <ul class="nav nav-tabs">
      <router-link
        v-for="(item, index) in tabs"
        :key="index"
        :to="item.url"
        v-slot="{ href, navigate, isActive }"
      >
        <span
          class="navlink"
          :class="isActive ? 'active' : ''"
          :href="href"
          @click="navigate"
          >{{ item.name }}</span
        >
      </router-link>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Tab",
  props: {
    tabs: Array
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.nav-tabs {
  display: flex;
  padding: 0;
  margin: 0;

  .navlink {
    text-decoration: none;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: rgba(50, 63, 75, 0.5);
    padding-bottom: 5px;
    cursor: pointer;
    margin-right: 10px;
    width: 110px;
  }

  .active {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #261940;
    border-bottom: 2px solid #e00b5b;
  }
}
</style>
